<a routerLink="/gestion/responses/{{form.uuid}}/{{state}}"
   style="text-decoration: none; color: #333333;"
   matTooltip="ouvrir la vue des demandes de ce formulaire">
  <div class="stats-number">
    {{cntState}}
  </div>
  <div class="stats-legend">{{cntState | i18nPlural: formSvc?.getLabelStatePlural(state)}}</div>
</a>
